const initialLoadingState = {
  isLoading: false,
  isStarted: false,
  error: null,
  isSucceeded: false,
};

export default initialLoadingState;
